import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import { settingsItemSx, StyledSwitch } from 'framework/ui/layout';
import usePurchaseOrderSettings from 'domain/finance/purchaseOrder/shared/Settings/usePurchaseOrderSettings';
import { useListContext } from 'framework/list';

const PurchaseOrderDeliveredInvoicesToggler = () => {
  const { areDeliversInvoicesVisible, setDeliversInvoicesVisible } = usePurchaseOrderSettings();
  const { loading } = useListContext();

  const onChangeCallback = (event: any) => {
    setDeliversInvoicesVisible(event.target.checked);
  };

  return (
    <FormControlLabel
      sx={settingsItemSx}
      control={
        <StyledSwitch
          color="primary"
          onChange={onChangeCallback}
          checked={areDeliversInvoicesVisible}
          dataOn="ON"
          dataOff="OFF"
          disabled={loading}
        />
      }
      label="Show delivered invoices"
    />
  );
};

export default PurchaseOrderDeliveredInvoicesToggler;
